<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 m-0">
        <div class="p-2" [ngClass.xl]="'d-flex justify-content-between'" [ngClass.md]="'d-flex justify-content-between'">
          <div class="p-0" [ngClass.sm]="'col-12'">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchShortLink()" />
          </div>
          <div [ngClass.sm]="'col-12 text-right mt-1 pr-0'">
            <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addNewShortLink)" *ngIf="_authenticationService.hasCapability('create_shortlink')">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 60 : 280"
          [footerHeight]="50"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [limit]="10"
          [rows]="filterShortLinkList"
        >
          <ngx-datatable-column [name]="'SHORTLINK' | translate" prop="id" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="cursor-pointer font-weight-bold" [ngbTooltip]="'COPY' | translate" (click)="copy(environment, row.id)">{{ environment }}{{ row.id }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DESTINATION' | translate" prop="original" width="250" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="line-height-1">{{ row.original }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FOR_USER' | translate" prop="user.complete_name" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a target="_blank" [href]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TITLE_DOCUMENT' | translate" prop="document.title" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a class="line-height-1" target="_blank" [href]="'/dashboard/single-document-file/' + row.document.id + '?hash=' + row.user.hash">{{ row.document.title }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" placement="left" *ngIf="_authenticationService.hasCapability('delete_shortlink')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
                <a
                  [routerLink]="'/dashboard/short-links/detail/' + row.id"
                  [ngbTooltip]="'DETAIL_SINGULAR' | translate"
                  placement="left"
                  class="ml-1 text-secondary"
                  *ngIf="_authenticationService.hasCapability('view_shortlink_detail')"
                >
                  <i [data-feather]="'eye'" size="19"></i>
                </a>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'FOR_USER' | translate" prop="user.complete_name" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row">
                <div class="col-12">
                  <a target="_blank" [href]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
                </div>
                <div class="col-12 d-flex flex-column">
                  <p class="font-weight-bold mb-0">{{ "SHORTLINK" | translate }}</p>
                  <span class="cursor-pointer m-0 text-break-line-1" (click)="copy(environment, row.id)">{{ environment }}{{ row.id }}</span>
                </div>
                <div class="col-12 my-1">
                  <p class="font-weight-bold mb-0">{{ "DESTINATION" | translate }}</p>
                  <a class="text-break-line-1 m-0" [href]="row.original">{{ row.original }}</a>
                </div>
                <div class="col-12">
                  <p class="font-weight-bold mb-0">{{ "TITLE_DOCUMENT" | translate }}</p>
                  <a class="text-break-line-1" target="_blank" [href]="'/dashboard/single-document-file/' + row.document.id + '?hash=' + row.user.hash">{{ row.document.title }}</a>
                </div>
                <div class="col-12 text-right mt-1">
                  <button
                    class="bg-transparent border-0 text-danger remove-item"
                    (click)="delete(row)"
                    [ngbTooltip]="'DELETE' | translate"
                    placement="left"
                    *ngIf="_authenticationService.hasCapability('delete_shortlink')"
                  >
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                  <a
                    [routerLink]="'/dashboard/short-links/detail/' + row.id"
                    [ngbTooltip]="'DETAIL_SINGULAR' | translate"
                    placement="left"
                    class="ml-1 pr-1 text-secondary"
                    *ngIf="_authenticationService.hasCapability('view_shortlink_detail')"
                  >
                    <i [data-feather]="'eye'" size="19"></i>
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!-- Modal ADD -->
<ng-template #addNewShortLink let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.INSERT_SHORTLINK" | translate }}</h3>
    <!--file-->
    <div class="form-group">
      <label>{{ "DOCUMENTS" | translate }}<sup class="text-danger">*</sup></label>
      <ng-select
        [items]="documents_list"
        bindLabel="title"
        bindValue="id"
        [(ngModel)]="document_id"
        [multiple]="false"
        [searchable]="true"
        [closeOnSelect]="true"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="documentChanged()"
        [clearable]="true"
        [openOnEnter]="false"
        [virtualScroll]="true"
      >
      </ng-select>
      <div class="font-error" *ngIf="showModalError && (!document_id || document_id < 1)">{{ "ERRORS.FIELD_DOCIMENTS" | translate }}</div>
    </div>
    <!--titolo-->
    <div class="form-group">
      <label>{{ "TITLE" | translate }}</label>
      <input type="text" class="form-control" [(ngModel)]="title" [ngModelOptions]="{ standalone: true }" [readonly]="document_id" />
    </div>
    <!--dipendente-->
    <div class="form-group">
      <label>{{ "EMPLOYEE" | translate }}</label>
      <ng-select
        [items]="employees"
        bindLabel="complete_name"
        [(ngModel)]="employee"
        [multiple]="false"
        [searchable]="true"
        [closeOnSelect]="true"
        [ngModelOptions]="{ standalone: true }"
        [clearable]="employee"
        [openOnEnter]="false"
        [virtualScroll]="true"
      >
      </ng-select>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="add()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "INSERT_BUTTON" | translate }}
    </button>
  </div>
</ng-template>
